module.exports = __webpack_public_path__ + "img/assetGreen.804fcd50.png";